module.exports = __webpack_public_path__ + "img/title.005b34c1.png";